import { Component,ViewChild, AfterViewInit ,ChangeDetectorRef} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {MatPaginator, MatSort} from '@angular/material';
import {merge, Observable, of as observableOf} from 'rxjs';
import {catchError, map, startWith, switchMap} from 'rxjs/operators';
import { DataUserService } from '../../../Services/data-user.service';
import { DataApiService } from '../../../Services/data-api.service';
import {MatDialog,MatDialogConfig, MAT_DIALOG_DATA} from '@angular/material';
import { ModificarUsuarioMotorizadoComponent } from '../modificar-usuario-motorizado/modificar-usuario-motorizado.component';

@Component({
  selector: 'app-ver-usuarios-mototizados',
  templateUrl: './ver-usuarios-mototizados.component.html',
  styleUrls: ['./ver-usuarios-mototizados.component.scss']
})
export class VerUsuariosMototizadosComponent implements AfterViewInit {

  constructor(
    private http: HttpClient,    
    private DataUser:DataUserService,
    private dataApi:DataApiService,
    private dialog: MatDialog
  ) { }
  exampleDatabase: ExampleHttpDatabase | null;
  data: GithubIssue[] = [];

  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;
  itemPerPage = 8;
  displayedColumns: string[] = [
    'id',   
    'name',
    'surname', 
    'foto', 
    'email' ,
    'codigo_motorizado',   
    'placa_moto',
    'telefono',   
    'acciones'
  ];

  public error = null;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  obtenerCodigoMotorizado(dato){
    return dato.split("||")[0];
  }
  obtenerPlacaMoto(dato){
    return dato.split("||")[1];
  }
  modificarUsuario(row){  
    this.dialog.closeAll();   
    this.dialog.open(ModificarUsuarioMotorizadoComponent,{
      width:"60%",
      data:{datos:row},
      disableClose: false,
      autoFocus:true
    });   
  
  }
  ngAfterViewInit() {
    this.exampleDatabase = new ExampleHttpDatabase(this.http,this.dataApi);

    // If the user changes the sort order, reset back to the first page.
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
    
    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          return this.exampleDatabase!.getRepoIssues(
            this.sort.active, this.sort.direction, this.paginator.pageIndex);
        }),
        map(data => {
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.resultsLength = data.total_count;
          return data.items;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          // Catch if the GitHub API has reached its rate limit. Return empty data.
          this.isRateLimitReached = true;
          return observableOf([]);
        })
      ).subscribe(data => this.data = data); 
  }
  

}
export interface GithubApi {
  items: GithubIssue[];
  total_count: number;
}

export interface GithubIssue {
  id:number,     
  email:string ,
  datos_motorizado:string,
  telefono1:string,
  name:string,
  surname:string,
  foto:string
}

/** An example database that the data source uses to retrieve data for the table. */
export class ExampleHttpDatabase{
  constructor(private http: HttpClient,private dataApi:DataApiService) {}

  getRepoIssues(sort: string, order: string, page: number): Observable<GithubApi> { 
    const href = this.dataApi.url; 
    const requestUrl =
        `${href}/mostrarUsuariosMotorizados/${page + 1}/8`;
   
    return this.http.get<GithubApi>(requestUrl);
  }  
}

